import type { ColorKey } from '@iheartjane/reefer';

import type { MenuCategory } from '../../../types';

export interface CategoryMetaBase {
  color: string;
  colorKey: ColorKey;
  selectedColor: string;
  title: string;
}

export type MenuCategoryTab = MenuCategory | 'alt-flower';

export const categories: Record<MenuCategoryTab, CategoryMetaBase> = {
  all: {
    color: '#FFFFFF',
    colorKey: 'purple',
    selectedColor: '#5E1FF0',
    title: 'All products',
  },
  'alt-flower': {
    color: '#DBECE4',
    colorKey: 'palm',
    selectedColor: '#4BA279',
    title: 'Flower',
  },
  edible: {
    color: '#FFEBCC',
    colorKey: 'tangerine',
    selectedColor: '#FF9900',
    title: 'Edible',
  },
  extract: {
    color: '#FFF3D2',
    colorKey: 'gold',
    selectedColor: '#FFC220',
    title: 'Extract',
  },
  featured: {
    color: '#DBECE4',
    colorKey: 'palm',
    selectedColor: '#4BA279',
    title: 'Featured',
  },
  flower: {
    color: '#DFD2FC',
    colorKey: 'purple',
    selectedColor: '#5E1FF0',
    title: 'Flower',
  },
  'jane-gold': {
    color: '#FFF3D2',
    colorKey: 'gold',
    selectedColor: '#FFC220',
    title: 'Jane Gold',
  },
  gear: {
    color: '#E0F1F6',
    colorKey: 'seafoam',
    selectedColor: '#63B8D2',
    title: 'Gear',
  },
  grow: {
    color: '#DBECE4',
    colorKey: 'palm',
    selectedColor: '#4BA279',
    title: 'Grow',
  },
  merch: {
    color: '#DBECE4',
    colorKey: 'palm',
    selectedColor: '#4BA279',
    title: 'Merch',
  },
  'pre-roll': {
    color: '#FFDDCC',
    colorKey: 'ember',
    selectedColor: '#FF5500',
    title: 'Pre-Roll',
  },
  specials: {
    color: '#F5D6EB',
    colorKey: 'sunset',
    selectedColor: '#CE349A',
    title: 'Deals',
  },
  tincture: {
    color: '#E8CCFA',
    colorKey: 'grape',
    selectedColor: '#8E00E6',
    title: 'Tincture',
  },
  topical: {
    color: '#F5D6EB',
    colorKey: 'sunset',
    selectedColor: '#CE349A',
    title: 'Topical',
  },
  vape: {
    color: '#F5D6EB',
    colorKey: 'sunset',
    selectedColor: '#CE349A',
    title: 'Vape',
  },
};
